<div class="w-full">
  @if (isLoading()) {
  <app-skeleton-match-information />
  } @else { @if (isError()) {
  <app-no-result />
  } @else { @if (matchInfoSignal()) {
  <div class="grid items-stretch w-full grid-cols-1 gap-4 lg:grid-cols-2">
    <app-card-info-match
      [title]="'MATCH_DETAILS_INFORMATION.STADIUM' | translate"
      [image]="urlIMG + 'location.png'"
    >
      <div class="flex flex-col w-full gap-3 px-5 py-4">
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.STADIUM" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Venue?.Name || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.CAPACITY" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Venue?.Capacity || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.CITY" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Venue?.City || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.REFEREE" | translate }}:</strong
          >
          {{ matchInfoSignal()?.RefereeName || "-" }}
        </p>
      </div>
    </app-card-info-match>

    <app-card-info-match
      [title]="'MATCH_DETAILS_INFORMATION.WEATHER' | translate"
      [image]="urlIMG + 'clime.png'"
    >
      <div class="flex flex-col w-full gap-3 px-5 py-4">
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.WEATHER" | translate }}:</strong
          >
          {{
            matchInfoSignal()?.Climatic?.Weather
              ? ("MATCH_DETAILS_WEATHER." + matchInfoSignal()?.Climatic?.Weather
                | translate)
              : "-"
          }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.TEMPERATURE" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Climatic?.Temperature || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.HUMIDITY" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Climatic?.Humidity || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.WIND" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Climatic?.Wind || "-" }}
        </p>
        <p class="font-roboto-400 text-13 text-grey-1 md:text-16">
          <strong class="font-roboto-700"
            >{{ "MATCH_DETAILS_INFORMATION.PRESSURE" | translate }}:</strong
          >
          {{ matchInfoSignal()?.Climatic?.Pressure || "-" }}
        </p>
      </div>
    </app-card-info-match>
  </div>
  } } }
</div>
